module.exports = {
  game: 'Game',
  gameNameTranslations: {
    'classic': 'Las Vegas',
    'egyptian': 'Egitto',
    'suits': 'Poker',
    'deep': 'Atlantide',
    'sacred': 'Archeologo',
    'goldrush': 'Vecchio West',
    'tribe': 'Sciamano',
    'phoenix': 'Fenice',
    'galleon': 'Veliero',
    'bubble': 'Bolle',
    'cosmos': 'Galassia',
    'lab': 'Laboratorio',
    'carnival': 'luna park',
    'invasion': 'UFO',
    'vikings': 'vichinghi',
    'pirate': 'Tesoro dei Pirati',
    'emoji': 'Emoji',
    'numbers': 'Numeri',
    'temple': 'Tempio',
    'parade': 'New Orleans',
    'wanted': 'western',
    'wildwood': 'bosco incantato',
    'bankbonus': 'Deal or No Deal: Il Gioco dei Pacchi',
    'bankvault': 'Deal or No Deal: Accetta o Non Accetta'
  },
  prize: {
    currencySymbol: '€',
    currencySymbolForPennies: '€'
  },
  jackpot: {
    won: 'JACKPOT WON',
    notWon: 'No jackpot winners this game',
    title: 'Jackpot'
  },
  winners: {
    gameWinnersModalTitle: 'Winners',
    previousGameWinners: 'Past 10 Winners',
    previousJackpotWinners: 'Past 10 Jackpot Winners',
    previousBonusGameWinners: 'Past 10 Bonus Game Winners',
    previousHamsterRaceBigWinners: 'Past 10 Largest Winners',
    previous100GameWinners: 'Past 100 Winners',
    tableHeaders: {
      gameId: 'Game Id',
      stamp: 'Stamp',
      winners: 'Winners',
      room: 'Room'
    },
    winnerTemplate: '{username} - €{prize} ',
    winnersWindow: {
      tableHeaders: {
        game: 'Game',
        username: 'Name',
        prize: 'Prize'
      },
      freeze: 'freeze',
      title: 'Game Winners',
      copy: 'Copy'
    },
    popup: {
      title: '',
      message: 'Complimenti {username} hai vinto {prize} in {gameName}',
      extendedMessage: 'Complimenti {username} hai vinto {prize} in {gameName} ({prizeType})'
    }
  },
  hamsterRace: {
    lastEigthWinnersTitle: 'Last 8 Winners',
    firstPlace: '1st',
    hamster: 'Hamster',
    wins: 'Wins',
    winners: {
      tableHeaders: {
        winningHamster: 'Winning Hamster'
      }
    }
  },
  rollercoaster: {
    lastSixCallsTitle: 'Last 6 Calls'
  },
  arcade: {
    winners: {
      tableHeaders: {
        winnerName: 'Winner Name',
        gameName: 'Game Name',
        prize: 'Prize',
        stamp: 'Stamp'
      }
    }
  },
  quizQuids: {
    tableHeaders: {
      winnerName: 'Winner Name',
      chatModeratorName: 'Chatmod Name',
      stamp: 'Stamp'
    }
  },
  pictureBingo: {
    winners: {
      tableHeaders: {
        theme: 'Theme'
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/it/game.js
// module id = Ofsg
// module chunks = 1